export default __webpack_public_path__ + "static/media/Sample-signature-image.46538db5.png";